// Wrapper for CariKart to work in tab mode without popup
import React from 'react';
import CariKart from './carikart';

export default function CariKartTab(props) {
    // In tab mode, always show and never use popup
    // Ensure ops is always defined
    const safeOps = props.ops || {};
    return (
        <CariKart
            {...props}
            ops={safeOps}
            formShow={true}
            inTabMode={true}
            onFormKapandi={() => {}}
        />
    );
}
